import React from 'react'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { ThemeProvider, withStyles } from '@material-ui/styles'
import App from './src/components/App'
import withTheme from '@material-ui/core/styles/withTheme'
import { initializePhoneCom, getAppConfig } from 'phonecom'
import Spinner from 'spinner'
import rootReducer from './src/reducers'

const store = createStore(rootReducer)

const styles = theme => ({
	spinnerStyle: {
		paddingTop: 20,
		margin: 'auto',
		width: 100
	},
	redirect: {
		height:			100,
		display:		'flex',
		justifyContent:	'center',
		alignItems:		'center'
	}
})

class MeetingsAdminApp extends React.Component {

	// componentDidMount = async () => {
	// 	let config = await getAppConfig()
	// 	window.V5PHONECOM = {v5ApiRoot: config.v5ApiRoot}
	// }
	state = {
		extensions: [],
		mappedExtensions: {},
		loaded: false
	}

	componentDidMount() {
		console.log('mounted')
		this.initialLoad()
	}

	initialLoad = async config => {
		let res = await initializePhoneCom(config)
		console.log(res)
		let mappedExtensions = this.mapExtensions(res.extensions)
		console.log(mappedExtensions)
		this.setState({extensions: res.extensions, mappedExtensions: mappedExtensions, loaded: true})
	}

	mapExtensions = extensions => {
		let mapped = {}
		extensions.map(e => mapped[e.extension_id] = e)
		return mapped
	}

	renderConfigureUsersRedirect = () => {
		const { classes } = this.props
		return (
			<div className={classes.redirect}>
				<span>In order to edit the meetings settings please use the Configure app by clicking <a target='_blank' href='https://configure.phone.com/users'>here</a></span>
			</div>
		)
	}

	render() {
		const { classes } = this.props
		return (
			<ThemeProvider theme={this.props.theme}>
				<Provider store={store}>
					{this.state.loaded ?
						window.V5PHONECOM.user_tiered ? this.renderConfigureUsersRedirect() :
						<App
							extensions			= {this.state.extensions}
							mappedExtensions	= {this.state.mappedExtensions}
							theme				= {this.props.theme}
						/>
					: <div className={classes.spinnerStyle}><Spinner/></div>}
				</Provider>
			</ThemeProvider>
		)
	}
}

export default withStyles(styles)(withTheme(MeetingsAdminApp))